/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowOutdoorPaintingDayTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowOutdoorPaintingDay,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Paint Outdoors!",
    "Outdoor Painting Day Awaits!",
    "Unleash Your Creativity in Nature!",
  ],
  title: "Outdoor Painting Day",
  description: "Organize a fun outdoor painting day.",
  longDescription:
    "Gather your friends for an exciting outdoor painting day! Choose a date, decide on subjects to paint, and plan refreshments!",
  emoji: "🎨",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Woodworker,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Outdoor Painting Day",
          emoji: "🎨",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we hold the outdoor painting day?",
          emoji: "📅",
          completeAction: {
            question: "Decide on subjects to paint?",
            description: "What subjects should we focus on during the day?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What subjects should we consider?",
                emoji: "🌄",
                completeAction: {
                  question: "Decide on refreshments?",
                  description: "What refreshments should we plan for the day?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What refreshments should we bring?",
                      emoji: "🧃",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Get Creative Outdoors!",
    outroDescription:
      "Your outdoor painting day plans are set! Enjoy the creativity!",
  },
};
